<template>
  <div v-click-outside="handleClickOutside" class="dim-picker">
    <div v-tooltip="$t('tooltip_two_dim').replace('$n',maxItems)" :class="['add-btn', {open,disabled}]" @click="open=!open">
      <div class="icon" />
      <div class="text">{{ $t('add') }}</div>
    </div>
    <div v-if="open" class="options">
      <div
        v-for="o in options"
        :key="o.id"
        class="option"
        @click="open=false; $emit('select',o.id)"
      >
        {{ o.label }}
      </div>  
    </div>
  </div>
</template>

<script>
// import { clientDimensionsList } from '@/utils/dimensionUtils'
import ClickOutside from 'vue-click-outside'
export default {
  directives: {
    ClickOutside,
  },
  props: ['disabled', 'dimensions', 'maxItems'],
  data() {
    return {
      open: false,
    }
  },
  computed: {
    options() {
      return this.dimensions
    },
  },
  methods: {
    handleClickOutside() {
      this.open = false
    },
  },
}
</script>

<style lang="stylus" scoped>
.dim-picker
  position: relative

  .add-btn
    display: flex
    align-items: center
    cursor: pointer

    &.disabled
      opacity: 0.2
      pointer-events: none

    .icon
      m-icon("add-blue", 16, $corporate_color)
      margin-right: vw(5px)

    .text
      m-font-size(12, 22)
      margin-top: 0.1em
      color: $corporate_color

  .options
    position: absolute
    top: calc(100% + 10px)
    right: 0
    z-index: 1
    padding: vw(8px) vw(12px)
    width: vw(160px)
    background-color: #fff
    box-shadow: 0 4px 20px 14px rgba(#000, 0.15)

    .option
      m-font-size(14, 22)
      m-letter-spacing(75)
      opacity: 0.75
      cursor: pointer

      &:hover
        opacity: 1

      &:not(:last-child)
        margin-bottom: vw(12px)
</style>
